/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */

import { Observable } from 'rxjs/Rx';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CartService } from "../../../services/cart/cart.service";
import { ViewEncapsulation } from '@angular/core/src/metadata/view';
import { AccountService } from './../../../services/customers/account.service';


@Component({
  selector: 'martmax-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [
    CartService,
    AccountService
  ],
})
export class HeaderComponent implements OnInit {

  public errors: any;
  public customer: any;
  public totalProducts: number;
  public currentCustomer: any;

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    public cartService: CartService,
    public accountService: AccountService,
  ) {
  }

  public ngOnInit() {
    this.getCustomerDetials();
    this.totalProducts = this.cartService.cartTotalItem();
  }

  /**
   * get customer details 
   */
  public getCustomerDetials() {
    if (!localStorage.getItem('currentCustomer')) {
      return;
    }
    this.currentCustomer = JSON.parse(localStorage.getItem('currentCustomer'));
    let params: any = {
      customer_access_token: this.currentCustomer.c_a_t,
    };
    this.accountService.show(params).subscribe(
      (data) => {
        if (data) {
          this.customer = data.customer;
        }
      },
      (error) => {
        this.errors = error;
      }
    );
  }
}





// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/components/home-page/header/header.component.ts